export var deepCompare = function (a, b) {
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length)
            return false;
        for (var i = 0; i < a.length; i++) {
            if (!deepCompare(a[i], b[i]))
                return false;
        }
        return true;
    }
    if (typeof a === 'object' && typeof b === 'object') {
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length)
            return false;
        for (var i = 0; i < aKeys.length; i++) {
            var key = aKeys[i];
            if (!deepCompare(a[key], b[key]))
                return false;
        }
        return true;
    }
    return false;
};
